/**
 * @class BlockMeganav
 * @classdesc BlockMeganav component interacts with editor events and dispatches events for
 * handling by parent navigation
 *
 * @extends Core.BlockComponent
 */
export default class BlockMeganav extends Core.BlockComponent {
  onSelect() {
    const selectEvent = new CustomEvent('meganav:select', { bubbles: true });
    this.el.dispatchEvent(selectEvent);
  }

  onDeselect() {
    const deselectEvent = new CustomEvent('meganav:deselect', { bubbles: true });
    this.el.dispatchEvent(deselectEvent);
  }
}
